// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__aMeIr","head":"ProcedureTableInfo_head__2k4B1"};